"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDisabledButton = exports.StyledInfoButton = exports.StyledInfoDiv = exports.StyledInvertedButton = exports.StyledVariantButton = exports.StyledMasterButton = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("./utils");
exports.StyledMasterButton = styled_components_1.default.button `
  ${({ fullWidth = false, iconButton = false, variant = 'contained', customStyles = {}, endAdornment, startAdornment, centered = false, navigationProps, small = false, }) => {
    const notTextButton = variant !== 'text';
    return (0, styled_components_1.css) `
      text-transform: uppercase;
      font-weight: ${theme_1.fonts.button.normal.fontWeight};
      font-size: ${theme_1.fonts.button.normal.fontSize};
      font-family: 'Inter', sans-serif;
      display: flex;
      flex-direction: ${startAdornment ? 'row-reverse' : 'row'};
      justify-content: ${(endAdornment || startAdornment) && !centered ? 'space-between' : 'center'};
      gap: ${theme_1.paddings.icon};
      align-items: center;
      transition: all 0.2s ease-in-out;
      width: ${(0, utils_1.getButtonWidth)(iconButton, fullWidth, small)};
      height: ${(0, utils_1.getButtonHeight)(iconButton, small)};
      min-height: ${small ? '36px' : variant === 'text' ? '20px' : '53px'};
      border-radius: ${iconButton ? '100%' : !notTextButton ? 0 : theme_1.borders.radius.button};
      padding: ${iconButton ? 0 : notTextButton ? theme_1.paddings.buttons.desktop : 0};

      &:active {
        transform: scale(0.98);
        border:${navigationProps ? `2px solid ${theme_1.primary.dark}` : 'none'};
      @media screen and (max-width: ${theme_1.grid.vpBreakpoints.VPS}px) {
        padding: ${iconButton ? 0 : notTextButton ? theme_1.paddings.buttons.mobile : 0};
      }
        
      ${{ ...customStyles }} 
      
      @media print {
        display: none;
      }
    `;
}}
`;
exports.StyledVariantButton = (0, styled_components_1.default)(exports.StyledMasterButton) `
  ${({ color = 'primary', variant = 'contained', navigationProps, isSticky, customStyles = {}, }) => {
    const buttonProps = theme_1.palette.buttons[color];
    const colorPalette = buttonProps[variant];
    const focusColor = colorPalette.focus.color;
    const focusBackgroundColor = colorPalette.focus.background;
    const position = navigationProps ? navigationProps.position : 'unset';
    return (0, styled_components_1.css) `
      position: ${position !== 'unset' ? (isSticky ? 'fixed' : 'absolute') : 'relative'};
      background-color: ${colorPalette.default.background};
      color: ${colorPalette.default.color};
      border: 2px solid ${colorPalette.default.border};
      ${isSticky && `box-shadow: ${theme_1.shadows.sticky};`}
      &:hover {
        background-color: ${colorPalette.hover.background};
        color: ${colorPalette.hover.color};
        border: 2px solid ${navigationProps ? theme_1.primary.dark : colorPalette.hover.border};
        ${(0, utils_1.setSVGStyles)(colorPalette.hover.color)};

        ${isSticky && `box-shadow: ${theme_1.shadows.sticky};`}
      }
      &:focus-visible {
        ${variant === 'text' && `border-radius: 8px; padding: 2px 4px;`}
        border: ${variant === 'outlined'
        ? 'none'
        : `3px solid ${colorPalette.default.color}`};
        box-shadow: ${variant === 'outlined'
        ? theme_1.defaultTheme.shadows.outlinedFocus(focusColor, focusBackgroundColor, focusColor, focusColor)
        : theme_1.defaultTheme.shadows.containedFocus(colorPalette.default.background, colorPalette.default.border)};
      }
      ${(0, utils_1.setSVGStyles)(colorPalette.default.color)};
      ${(0, utils_1.SetPosition)(position)}
      ${{ ...customStyles }}
    `;
}}
`;
exports.StyledInvertedButton = (0, styled_components_1.default)(exports.StyledMasterButton) `
  ${({ navigationProps, isSticky, customStyles = {}, }) => {
    const buttonProps = theme_1.palette.buttons.primary.inverted;
    const position = navigationProps ? navigationProps.position : 'auto';
    return (0, styled_components_1.css) `
      position: ${(navigationProps === null || navigationProps === void 0 ? void 0 : navigationProps.position) ? 'absolute' : 'relative'};
      background-color: ${buttonProps.default.background};
      color: ${buttonProps.default.color};
      border: 2px solid transparent;
      box-shadow: ${navigationProps || isSticky ? theme_1.shadows.sticky : 'none'};

      &:hover {
        background-color: ${buttonProps.hover.background};
        color: ${buttonProps.hover.color};
        border: 2px solid ${!isSticky && navigationProps ? theme_1.primary.dark : 'transparent'};
        ${isSticky &&
        (0, styled_components_1.css) `
          box-shadow: ${theme_1.shadows.sticky};
        `}
        ${(0, utils_1.setSVGStyles)(buttonProps.hover.color)};
      }
      &:focus-visible {
        box-shadow: ${navigationProps
        ? theme_1.defaultTheme.shadows.navigationFocus(theme_1.primary.dark)
        : isSticky
            ? theme_1.defaultTheme.shadows.stickyFocus
            : theme_1.defaultTheme.shadows.outlinedFocus(buttonProps.focus.color, buttonProps.focus.background, buttonProps.focus.color, theme_1.grayScale[50])};
        border: 2px solid ${isSticky || navigationProps ? theme_1.primary.dark : 'transparent'};
      }
      ${(0, utils_1.setSVGStyles)(buttonProps.default.color)};
      ${(0, utils_1.SetPosition)(position)}
      ${{ ...customStyles }}
    `;
}}
`;
exports.StyledInfoDiv = styled_components_1.default.div `
  ${({ color = 'primary', variant = 'contained', disabled = false, customStyles = {}, }) => {
    const buttonProps = theme_1.palette.buttons[color];
    const colorPalette = buttonProps[variant];
    return (0, styled_components_1.css) `
      width: 10rem;
      height: 10rem;
      background: ${disabled
        ? buttonProps.disabled.info.border
        : colorPalette.default.border};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      &:focus-within:focus-visible {
        border: solid 2px ${colorPalette.focus.background};
        box-shadow: ${theme_1.defaultTheme.shadows.containedFocus(colorPalette.focus.border, colorPalette.focus.border)};
      }
      @media (max-width: 768px) {
        width: 9rem;
        height: 9rem;
      }
      ${{ ...customStyles }}
    `;
}}
`;
exports.StyledInfoButton = (0, styled_components_1.default)(exports.StyledMasterButton) `
  ${({ disabled = false, customStyles = {}, }) => {
    const buttons = theme_1.palette.buttons.primary;
    const buttonProps = buttons.info;
    return (0, styled_components_1.css) `
      background-color: ${disabled
        ? buttons.disabled.info.background
        : buttonProps.default.background};
      color: ${disabled ? buttons.disabled.info.color : buttonProps.default.color};
      font-weight: ${theme_1.fonts.button.large.fontWeight};
      font-size: ${theme_1.fonts.button.large.fontSize};
      line-height: ${theme_1.fonts.button.large.lineHeight};
      width: 7.5rem;
      height: 7.5rem;
      border: none;
      border-radius: 50%;
      transition: all 0.5s ease;
      padding: 3.5rem;
      box-shadow: ${theme_1.defaultTheme.shadows.infoShadow('#000000')};
      &:hover {
        ${disabled
        ? ''
        : `
        padding: 4.07rem;
        background-color: ${buttonProps.hover.background};
        color: ${buttonProps.hover.color};
      `}
        ${(0, utils_1.setSVGStyles)(buttonProps.hover.color)};
      }
      &:active {
        transform: none;
        padding: 4.07rem;
      }
      ${(0, utils_1.setSVGStyles)(buttonProps.default.color)};

      @media (max-width: 768px) {
        width: 6rem;
        height: 6rem;
        padding: 3.4rem;
        &:hover {
          padding: 3.7rem;
        }
        &:focus {
          padding: 3.7rem;
        }
      }

      ${disabled &&
        (0, styled_components_1.css) `
        pointer-events: none;
        cursor: not-allowed;
        user-select: none;
      `};
      ${{ ...customStyles }}
    `;
}}
`;
exports.StyledDisabledButton = (0, styled_components_1.default)(exports.StyledMasterButton) `
  ${({ color = 'primary', variant = 'contained', navigationProps, isSticky, customStyles = {}, }) => {
    const buttonProps = theme_1.palette.buttons[color].disabled;
    const colorPalette = buttonProps[variant];
    return (0, styled_components_1.css) `
      position: ${(navigationProps === null || navigationProps === void 0 ? void 0 : navigationProps.position) ? 'absolute' : 'relative'};
      pointer-events: none;
      user-select: none;
      background-color: ${isSticky ? theme_1.grayScale[200] : colorPalette.background};
      color: ${isSticky ? theme_1.grayScale[400] : colorPalette.color};
      border: ${variant === 'inverted' ? 'none' : `2px solid ${colorPalette.border}`};
      box-shadow: ${(navigationProps === null || navigationProps === void 0 ? void 0 : navigationProps.position) ? theme_1.shadows.hover : 'none'};
      &:active,
      &:focus,
      &:hover {
        outline: none;
        box-shadow: none;
      }
      ${(0, utils_1.setSVGStyles)(isSticky ? theme_1.grayScale[400] : colorPalette.color)};
      ${{ ...customStyles }}
    `;
}}
`;
//# sourceMappingURL=styles.js.map